<div class="modern-calendar">
  <div class="calendar-header">
    <button class="month-nav prev-month" (click)="goToPreviousMonth()" [disabled]="disablePastDays && displayYear === currentDate.getFullYear() && displayMonth === currentDate.getMonth()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="15 18 9 12 15 6"></polyline>
      </svg>
    </button>
    <div class="month-display">{{ formatMonthYear() }}</div>
    <button class="month-nav next-month" (click)="goToNextMonth()">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <polyline points="9 18 15 12 9 6"></polyline>
      </svg>
    </button>
  </div>

  <div class="weekdays">
    @for (day of weekDays; track day) {
      <div class="weekday">{{ day }}</div>
    }
  </div>

  <div class="calendar-grid" role="grid" aria-label="Kalender">
    @for (day of calendarDays; track day.date.getTime()) {
      <div
      [ngClass]="{
        'calendar-day': true,
        'other-month': !day.isCurrentMonth,
        'past-day': day.isPast,
        'disabled': day.isDisabled,
        'selected': day.isSelected,
        'today': day.isToday,
        'has-course-session': day.hasCourseSession,
        'in-highlighted-week': day.inHighlightedWeek
      }"
        [attr.role]="day.isDisabled ? null : 'button'"
        [attr.tabindex]="day.isDisabled ? -1 : 0"
        [attr.aria-label]="formatDayAriaLabel(day)"
        [attr.aria-disabled]="day.isDisabled || null"
        [attr.aria-selected]="day.isSelected || null"
        (click)="selectDay(day)"
        (keydown.enter)="selectDay(day)"
        (keydown.space)="selectDay(day); $event.preventDefault()">
        {{ day.dayNumber }}
      </div>
    }
  </div>

  <div class="calendar-footer">
    <button class="today-btn" (click)="goToToday()" aria-label="Gehe zu heute">Heute</button>
  </div>

  <div class="calendar-legend">
    <div class="legend-item">
      <span class="legend-indicator legend-course"></span>
      <span class="legend-text">Kurs verfügbar</span>
    </div>
    @if (highlightedWeekStart) {
      <div class="legend-item">
        <span class="legend-indicator legend-week"></span>
        <span class="legend-text">Gewählte Woche</span>
      </div>
    }
  </div>
</div>